import React from 'react';
import DataTable from 'react-data-table-component';
import { IconEdit, IconEye, IconTrash } from '@tabler/icons-react';

const pickTimestamp = (row, camelKey, snakeKey) => row[camelKey] ?? row[snakeKey] ?? null;

const tenantAccessPath = (slug) => (slug ? `/hospitals/${slug}` : '-');

const formatDate = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString('id-ID', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const DatatableCpanelTenants = ({
  listTenants,
  search,
  handleChangeSearch,
  handleShowTenant,
  handleEditTenant,
  handleHapusTenant,
}) => {
  const columns = [
    {
      name: 'Aksi',
      minWidth: '200px',
      width: '200px',
      style: {
        paddingRight: '1.5rem',
      },
      headStyle: {
        paddingRight: '1.5rem',
      },
      cell: (row) => (
        <div className="cpanel-tenant-actions d-flex flex-nowrap align-items-center gap-1">
          <button
            className="btn btn-sm btn-outline-info"
            type="button"
            title="Detail Tenant"
            onClick={() => handleShowTenant(row)}
          >
            <IconEye stroke={2} />
          </button>
          <button
            className="btn btn-sm btn-outline-warning"
            type="button"
            title="Edit Tenant"
            onClick={() => handleEditTenant(row)}
          >
            <IconEdit stroke={2} />
          </button>
          <button
            className="btn btn-sm btn-outline-danger"
            type="button"
            title="Hapus Tenant"
            onClick={() => handleHapusTenant(row)}
          >
            <IconTrash stroke={2} />
          </button>
        </div>
      ),
    },
    {
      name: 'Alamat Akses',
      minWidth: '220px',
      style: {
        paddingLeft: '0.75rem',
      },
      headStyle: {
        paddingLeft: '0.75rem',
      },
      cell: (row) =>
        row.slug ? (
          <a href={tenantAccessPath(row.slug)} target="_blank" rel="noreferrer">
            {tenantAccessPath(row.slug)}
          </a>
        ) : (
          '-'
        ),
    },
    {
      name: 'Slug',
      minWidth: '160px',
      selector: (row) => row.slug,
    },
    {
      name: 'Deskripsi',
      minWidth: '280px',
      cell: (row) => (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{row.description}</div>
      ),
    },
    {
      name: 'Kode Verifikasi',
      minWidth: '160px',
      selector: (row) => row.verificationCode || row.verification_code || '-',
    },
    {
      name: 'Dibuat',
      minWidth: '180px',
      cell: (row) => formatDate(pickTimestamp(row, 'createdAt', 'created_at')),
    },
    {
      name: 'Diperbarui',
      minWidth: '180px',
      cell: (row) => formatDate(pickTimestamp(row, 'updatedAt', 'updated_at')),
    },
  ];

  return (
    <>
      <h5 className="card-title mb-3">Daftar Tenant</h5>
      <input
        type="text"
        placeholder="Cari alamat akses, slug, kode verifikasi, atau deskripsi"
        className="form-control cpanel-tenants-search mb-3"
        value={search}
        onChange={(e) => handleChangeSearch(e.target.value)}
      />
      <DataTable
        className="cpanel-tenants-datatable"
        columns={columns}
        data={listTenants}
        pagination
        fixedHeader
        highlightOnHover
        noDataComponent={
          <div className="py-5 text-muted">Belum ada data tenant.</div>
        }
      />
    </>
  );
};

export default DatatableCpanelTenants;
